<template>
  <div>
    <div v-if="!dataLoaded">
      <v-progress-circular indeterminate color="primary" class="ret-center-absolute"></v-progress-circular>
    </div>
    <div v-if="dataLoaded">
      <v-card class="ret-card">
        <v-card-title>
          <!--          <v-text-field
                     append-icon="search"
                     :label="$t('search')"
                     single-line
                     hide-details
                     v-model="search"
                   ></v-text-field> -->
          <v-spacer></v-spacer>
          <v-btn color="accent" fab small dark @click="$router.push({name: `${model.name}/new`})">
            <v-icon>add</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <ret-tree :model="model" :nodes="items.roots()"
                    @itemClick="onItemClick">
          </ret-tree>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import displayHelpers from '../helpers/display-helpers.es6'
import itemsHelpers from '../helpers/items-helpers.es6'
import RetTree from '../shared/components/ret-tree.vue'

export default {
  mixins: [displayHelpers, itemsHelpers],
  data () {
    return {
      model: {
        // Tree data
        name: 'owners',
        tree: true,
        sort_col: 'name'
      },
      headers: [
        { text: this.$tc('owners.entity-name', 1), value: 'name', align: 'left' },
        { text: 'Parent id', value: 'parentId' }
      ]
    }
  },
  methods: {
    onItemClick (itemId) {
      this.$router.push({ name: `${this.model.name}/id`, params: { id: itemId } })
    }
  },
  components: {
    RetTree
  }
}
</script>
